__turbopack_context__.v({
  "actionAccept": "CookieBanner-module__a17icW__actionAccept",
  "actionButton": "CookieBanner-module__a17icW__actionButton",
  "actionReject": "CookieBanner-module__a17icW__actionReject",
  "actions": "CookieBanner-module__a17icW__actions",
  "banner": "CookieBanner-module__a17icW__banner",
  "cookie-banner-enter": "CookieBanner-module__a17icW__cookie-banner-enter",
  "description": "CookieBanner-module__a17icW__description",
  "link": "CookieBanner-module__a17icW__link",
  "logo": "CookieBanner-module__a17icW__logo",
  "logoWrap": "CookieBanner-module__a17icW__logoWrap",
  "title": "CookieBanner-module__a17icW__title",
});
